import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  FILTER_LOCAL_DISPLAY_LIST,
  CLEAR_TYPEAHEAD_LIST_FOR_FIELDID,
} from 'AppSrc/core/actions/actions-typeahead-lists';


const typeaheadListDefaultState = {
  typeaheadListsById: {},
};

const filterLocalDisplayList = (state, action) => ({
  ...state,
  typeaheadListsById: {
    ...state.typeaheadListsById,
    [action.payload.fieldId]: {
      ...state.typeaheadListsById[action.payload.fieldId],
      displayList: action.payload.displayList,
      displayListFiltered: true,
    },
  },
});

const clearTypeaheadListForFieldId = (state, action) => ({
  ...state,
  typeaheadListsById: {
    ...state.typeaheadListsById,
    [action.payload.fieldId]: {
      ...state.typeaheadListsById[action.payload.fieldId],
      displayList: [],
      displayListFiltered: false,
    },
  },
});



const actionHandlers = {
  [FILTER_LOCAL_DISPLAY_LIST]: filterLocalDisplayList,
  [CLEAR_TYPEAHEAD_LIST_FOR_FIELDID]: clearTypeaheadListForFieldId,
};

const typeaheadListReducer = createReducer(typeaheadListDefaultState, actionHandlers);


export {
  typeaheadListDefaultState,
  typeaheadListReducer,
};
